import { render, staticRenderFns } from "./EditWaitWindowAction.vue?vue&type=template&id=4622c2ca&"
import script from "./EditWaitWindowAction.vue?vue&type=script&lang=js&"
export * from "./EditWaitWindowAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports